<template>
  <div>
    <!-- Table Component -->
    <component
      :is="tableComponent"
      v-bind="tableProps"
      @setDataStudent="$emit('student-selected', $event)"
    />

    <!-- Create Component -->
    <StudentsCreateComponent
      v-if="showCreateComponent"
      v-bind="createProps"
      @reload_table="$emit('reload-requested', $event)"
    />
  </div>
</template>

<script>
import StudentsTableSuperadminComponent from '../DataTable-Superadmin.vue'
import StudentsTableComponent from '../DataTable.vue'
import StudentsCreateComponent from '../CreateStudentContainer.vue'

export default {
  name: 'StudentTableView',
  
  components: {
    StudentsTableSuperadminComponent,
    StudentsTableComponent,
    StudentsCreateComponent
  },

  props: {
    userRole: { type: String, required: true },
    tableConfig: { type: Object, required: true },
    createConfig: { type: Object, required: true },
    reloadTable: { type: Boolean, default: false }
  },

  emits: ['student-selected', 'reload-requested'],

  computed: {
    tableComponent() {
      return this.userRole === 'SU' 
        ? 'StudentsTableSuperadminComponent'
        : 'StudentsTableComponent'
    },

    tableProps() {
      return {
        ...this.tableConfig,
        trashes: false,
        reloadTable: this.reloadTable
      }
    },

    createProps() {
      return {
        ...this.createConfig,
        headertab: [],
        vista: 'tabla'
      }
    },

    showCreateComponent() {
      return ['admin', 'SU'].includes(this.userRole)
    }
  }
}
</script>